// extracted by mini-css-extract-plugin
export default {"enter":"menuStyles_enter__Tp96n","enterActive":"menuStyles_enterActive__Jix2I","exit":"menuStyles_exit__R4D6G","exitDone":"menuStyles_exitDone__PPe7D"};